<template>
  <div>
    <resumo :resumo="resumo" :permission="permission" />
    <listagem
      ref="listagem"
      :tela="permission"
      :headers="headers.filter((item) => item.display !== false)"
      :data="agendamentos"
      :dataTotal="dataTotal"
      :pageSize="page_size"
      :extra_params="extra_params"
      @handleGet="handleGet"
      @getDownload="download"
      @getCustomNavioDownload="getCustomNavioDownload"
      @getCustomCargaDownload="getCustomCargaDownload"
      @getCustomTransbordoDownload="getCustomTransbordoDownload"
      @getCustomRodoviarioDownload="getCustomRodoviarioDownload"
      @getCustomExpedicaoRecebimentoDownload="
        getCustomExpedicaoRecebimentoDownload
      "
      @getCustomAcertoPesoDownload="getCustomAcertoPesoDownload"
      @getCustomExpedicaoFabricaDownload="getCustomExpedicaoFabricaDownload"
      @getCustomNavioCargaDescargaDownload="getCustomNavioCargaDescargaDownload"
      :canDownload="canDownload"
      :canDownloadNavio="canDownloadNavio"
      :canDownloadCarga="canDownloadCarga"
      :canDownloadTransbordo="canDownloadTransbordo"
      :canDownloadRodoviario="canDownloadRodoviario"
      :canDownloadExpedicaoRecebimento="canDownloadExpedicaoRecebimento"
      :canDownloadExpedicaoFabrica="canDownloadExpedicaoFabrica"
      :canDownloadNavioCargaDescarga="canDownloadNavioCargaDescarga"
      :titleDownloadNavioCargaDescarga="titleDownloadNavioCargaDescarga"
      :isRelatorio="true"
    />
  </div>
</template>

<script>
import Listagem from '@/components/patio/GerenciamentoServico/listagem/Componente.vue'
import Resumo from '@/components/patio/GerenciamentoServico/Resumo.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import { BasicPermissions, Sequences } from '@/utils/permissions'
import { getUrl, downloadUrl } from '@/utils/index'

export default {
  name: 'RelatorioCargaDescargaListConcluidos',
  props: {
    headers: {
      type: Array,
      required: true,
    },
  },
  components: {
    Listagem,
    Resumo,
  },
  data() {
    return {
      page_size: 15,
      dataTotal: 0,
      resumo: undefined,
      extra_params: {
        tempo_medio: false,
      },
    }
  },
  computed: {
    ...mapState('patio', ['agendamentos', 'regioes']),
    ...mapState('auth', ['empresaAtual', 'user']),
    ...mapState('relatorioCargaDescarga', ['params']),
    permission() {
      return Sequences.CargaDescarga.toString()
    },
    canList() {
      return this.$canDo(BasicPermissions.VISUALIZAR, this.permission)
    },
    canDownload() {
      return Object.keys(this.params).length > 0
    },
    isRelatorioMasterSantarem() {
      return this.empresaAtual?.cnpj === '15011519000223'
    },
    isRelatorioMasterSfs() {
      const allowedCnpjs = [
        '00000000000001',
        '15011519000304',
        '15011519000142',
        '28631030000115',
        '28941241000316',
        '28941241000235',
      ]
      return allowedCnpjs.includes(this.empresaAtual?.cnpj)
    },
    canDownloadMaster() {
      return (
        this.canDownload &&
        (this.params.data_agendamento_inicio ||
          this.params.data_triagem_inicio ||
          this.params.data_cota_inicio ||
          this.params.data_pedido_inicio ||
          this.params.data_pesagem_entrada_inicio ||
          this.params.data_pesagem_saida_inicio ||
          this.params.sequencia_pesagem ||
          this.params.data_saida_patio_inicio ||
          this.params.data_conclusao_inicio) &&
        (this.params.data_agendamento_fim ||
          this.params.data_triagem_fim ||
          this.params.data_cota_fim ||
          this.params.data_pedido_fim ||
          this.params.data_pesagem_entrada_fim ||
          this.params.data_pesagem_saida_fim ||
          this.params.data_saida_patio_fim ||
          this.params.data_conclusao_fim)
      )
    },
    canDownloadNavio() {
      return Boolean(
        this.canDownloadMaster &&
          this.isRelatorioMasterSfs &&
          (typeof this.params.navio === 'object'
            ? this.params.navio?.value
            : this.params.navio)
      )
    },
    canDownloadCarga() {
      return Boolean(
        this.canDownloadMaster &&
          (typeof this.params.tipo_operacao === 'object'
            ? this.params.tipo_operacao?.value
            : this.params.tipo_operacao) == '1' &&
          ![
            // Servicos com relatorios proprios
            'Transbordo Interno',
            'Transbordo Externo',
            'Carga Navio',
            'Descarga Navio',
          ].includes(
            typeof this.params.servico_triado === 'object'
              ? this.params.servico_triado?.value
              : this.params.servico_triado
          )
      )
    },
    canDownloadTransbordo() {
      return Boolean(
        this.canDownloadMaster &&
          this.isRelatorioMasterSfs &&
          (typeof this.params.servico_triado === 'object'
            ? this.params.servico_triado?.value
            : this.params.servico_triado) === 'Transbordo Interno'
      )
    },
    canDownloadRodoviario() {
      return Boolean(
        this.canDownloadMaster &&
          (typeof this.params.tipo_operacao === 'object'
            ? this.params.tipo_operacao?.value
            : this.params.tipo_operacao) == '2' &&
          !(typeof this.params.navio?.value === 'object'
            ? this.params.navio?.value
            : this.params.navio) &&
          ![
            // Servicos com relatorios proprios
            'Transbordo Interno',
            'Transbordo Externo',
            'Carga Navio',
            'Descarga Navio',
          ].includes(
            typeof this.params.servico_triado === 'object'
              ? this.params.servico_triado?.value
              : this.params.servico_triado
          )
      )
    },
    canDownloadExpedicaoRecebimento() {
      return Boolean(
        this.canDownloadMaster &&
          (typeof this.params.servico_triado === 'object'
            ? this.params.servico_triado?.value
            : this.params.servico_triado) === 'Transbordo Externo'
      )
    },
    canDownloadExpedicaoFabrica() {
      return Boolean(
        this.canDownloadMaster &&
          this.isRelatorioMasterSfs &&
          (typeof this.params.tipo_operacao?.value === 'object'
            ? this.params.tipo_operacao?.value
            : this.params.tipo_operacao) == '1' &&
          ![
            // Servicos com relatorios proprios
            'Transbordo Interno',
            'Transbordo Externo',
            'Carga Navio',
            'Descarga Navio',
          ].includes(
            typeof this.params.servico_triado === 'object'
              ? this.params.servico_triado?.value
              : this.params.servico_triado
          )
      )
    },
    canDownloadNavioCargaDescarga() {
      return Boolean(
        this.canDownloadMaster &&
          this.isRelatorioMasterSantarem &&
          ['Carga Navio', 'Descarga Navio'].includes(
            typeof this.params.servico_triado === 'object'
              ? this.params.servico_triado?.value
              : this.params.servico_triado
          )
      )
    },
    titleDownloadNavioCargaDescarga() {
      if (!this.canDownloadNavioCargaDescarga) return ''
      return `Relatório de ${(
        typeof this.params.servico_triado === 'object'
          ? this.params.servico_triado?.value
          : this.params.servico_triado
      )}`
    },
  },
  methods: {
    ...mapMutations('patio', ['SET_AGENDAMENTOS']),
    ...mapActions('patio', [
      'getAllAgendamentosByParams',
      'getAgendamentoRelatorio',
      'getRelatorioServico',
      'getRegioesColaborator',
      'getRelatorioServicoDetalhado',
    ]),
    ...mapActions('template', ['successMessage', 'errorMessage']),
    handleGet(event) {
      this.options = event
      this.page_size = event.itemsPerPage
      this.handleGetAgendamentos(event.page)
    },
    async download() {
      console.log('download from RelatorioCargaDescargaListConcluidos')
      await this.getDownload()
    },
    async getDownload() {
      console.log('getDownload from RelatorioCargaDescargaListConcluidos')
      if (!this.canDownload) return
      if (
        this.empresaAtual.representantes.length > 0 &&
        this.params.regiao == undefined
      ) {
        await this.getRegioesColaborator()

        if (this.regioes.length > 0) {
          this.params.regiao = this.regioes.map((regiao) => regiao.public_id)
          this.params.representante = this.user.public_id
        }
      }
      this.$emit('loading')
      let data = []
      try {
        const cleanedParams = this.cleanParams(this.params)
        const cleanedExtraParams = this.cleanParams(this.extra_params)

        const indicadores = this.headers
          .filter((item) => item.value != 'actions')
          .map((item) => item.text)
          .join(',')
        const path = 'api/v1/relatorios/agendamentos/download/'
        const params = {
          proprietario: this.empresaAtual.public_id,
          status: 'CONCLUÍDO',
          ...cleanedParams,
          ...cleanedExtraParams,
          indicadores,
        }
        const url = getUrl(path, params)
        await downloadUrl(url)
      } catch (error) {
        console.log(error)
        this.errorMessage(
          'Não foi possível baixar a planilha. Tente novamente mais tarde.'
        )
      } finally {
        this.$emit('loaded')
      }
      return data
    },
    async handleGetAgendamentos(page = 1, new_page_size = undefined) {
      if (!Object.keys(this.params).length) return

      if (new_page_size) {
        this.page_size = new_page_size
      }
      const page_size = this.page_size
      this.$emit('loading')
      try {
        const { sortBy, sortDesc } = this.options
        let ordering
        if (
          sortBy &&
          sortBy.length === 1 &&
          sortDesc &&
          sortDesc.length === 1
        ) {
          ordering = sortBy[0]
          ordering = sortDesc[0] ? '-' + ordering : ordering
          ordering = ordering.replaceAll('.', '__')
        }
        if (
          this.empresaAtual.representantes.length > 0 &&
          this.params.regiao == undefined
        ) {
          await this.getRegioesColaborator()
          if (this.regioes.length > 0) {
            this.params.regiao = this.regioes.map((regiao) => regiao.public_id)
            this.params.representante = this.user.public_id
          }
        }

        const cleanedParams = this.cleanParams(this.params)
        const cleanedExtraParams = this.cleanParams(this.extra_params)

        const { results, count, resumo } = await this.getAgendamentoRelatorio({
          page,
          page_size: (page_size === -1 && this.dataTotal) || page_size,
          ordering,
          proprietario: this.empresaAtual.public_id,
          ...cleanedParams,
          ...cleanedExtraParams,
        })
        this.resumo = resumo
        this.data = results
        this.dataTotal = count
      } catch (e) {
        if (e.response.status === 404) {
          this.errorMessage('Página não encontrada')
        }
      } finally {
        this.$emit('loaded')
      }
    },
    cleanParams(obj) {
      console.log(obj)
      const result = {}

      for (const [key, val] of Object.entries(obj)) {
        if (!val) continue

        let actualVal = val.value !== undefined ? val.value : val

        // Ignorar vazio
        if (actualVal === '' || actualVal === null) continue

        // 📌 Campos de data no formato DD/MM/YYYY ou DD/MM/YYYY HH:mm:ss
        if (
          typeof actualVal === 'string' &&
          actualVal.match(/^\d{2}\/\d{2}\/\d{4}/)
        ) {
          const [datePart, timePart] = actualVal.split(' ')
          const [day, month, year] = datePart.split('/')

          // Se não tem hora → define conforme início/fim
          const time = timePart
            ? timePart
            : key.includes('_fim')
            ? '23:59:59'
            : '00:00:00'

          result[key] = `${year}-${month}-${day} ${time}`
          continue
        }

        // 📌 Se for objeto com public_id → envia só ele
        if (actualVal && typeof actualVal === 'object') {
          if (actualVal.cliente_id) {
            result[key] = actualVal.cliente_id
          } else if (actualVal.value !== undefined) {
            result[key] = actualVal.value
          }
          continue
        }

        // 📌 Valor simples
        result[key] = actualVal
      }

      return result
    },

    async getCustomDownload(report_type) {
      if (!this.canDownload) return
      this.$emit('loading')
      try {
        // 🔥 Limpa os params antes de enviar
        const cleanedParams = this.cleanParams(this.params)
        const cleanedExtraParams = this.cleanParams(this.extra_params)
        const indicadores = this.headers
          .filter((item) => item.value != 'actions')
          .map((item) => item.text)
          .join(',')
        const path = 'api/v1/relatorios/agendamentos/download-custom/'
        const params = {
          proprietario: this.empresaAtual.public_id,
          status: 'CONCLUÍDO',
          ...cleanedParams,
          ...cleanedExtraParams,
          indicadores,
          report_type: report_type,
        }
        console.log('params being sent to backend:', {
          path,
          params,
          fullUrl: getUrl(path, params),
        })
        const url = getUrl(path, params)
        await downloadUrl(url)
      } catch (error) {
        console.error(error)
        this.errorMessage(
          'Não foi possível gerar o relatório. Tente novamente mais tarde.'
        )
      } finally {
        this.$emit('loaded')
      }
    },
    async getCustomNavioDownload() {
      // Relatório de Recebimento Navio
      this.getCustomDownload('navio')
    },
    async getCustomCargaDownload() {
      // Relatório de Expedição de Carga
      this.getCustomDownload('carga')
    },
    async getCustomTransbordoDownload() {
      // Relatório de Transbordo Interno
      this.getCustomDownload('transbordo')
    },
    async getCustomRodoviarioDownload() {
      // Relatório de Recebimento Rodoviário
      this.getCustomDownload('recebimento_rodoviario')
    },
    async getCustomExpedicaoRecebimentoDownload() {
      // Relatório de Expedição e Recebimento
      this.getCustomDownload('expedicao_recebimento')
    },
    async getCustomAcertoPesoDownload() {
      // Relatório de Acerto de Peso
      this.getCustomDownload('acerto_peso')
    },
    async getCustomExpedicaoFabricaDownload() {
      // Relatório de Expedição de Fabrica
      this.getCustomDownload('expedicao_fabrica')
    },
    async getCustomNavioCargaDescargaDownload() {
      // Relatório de Expedição de Fabrica
      this.getCustomDownload('navio_carga_descarga')
    },

    search() {
      this.handleGetAgendamentos()
    },
  },
}
</script>
